











import { defineComponent, PropType } from '@nuxtjs/composition-api'
import helper from '~/utils/helper'
import { StoryblokComponent } from '~/types/storyblok-vue'

export interface GaSvg extends StoryblokComponent<'svg'> {
  content: StoryblokComponent<any>[]
  custom_classes: string
  xmlns: string
  viewBox: string
  version: string
  preserveAspectRatio: string
  fill: string
  patternUnits: string
  x: string
  y: string
  points: string
  width: string
  height: string
}

export default defineComponent({
  props: {
    blok: {
      type: Object as PropType<GaSvg>,
      default: () => {}
    }
  },
  setup(props) {
    const { concatClasses, dashify } = helper()
    const classes = concatClasses(props.blok)

    const attr = {
      ...(classes && { class: classes }),
      ...(props.blok.xmlns && { xmlns: props.blok.xmlns }),
      ...(props.blok.viewBox && { viewBox: props.blok.viewBox }),
      ...(props.blok.version && { version: props.blok.version }),
      ...(props.blok.preserveAspectRatio && { preserveAspectRatio: props.blok.preserveAspectRatio }),
      ...(props.blok.fill && { fill: props.blok.fill }),
      ...(props.blok.patternUnits && { patternUnits: props.blok.patternUnits }),
      ...(props.blok.x && { x: props.blok.x }),
      ...(props.blok.y && { y: props.blok.y }),
      ...(props.blok.points && { points: props.blok.points }),
      ...(props.blok.width && { width: props.blok.width }),
      ...(props.blok.height && { height: props.blok.height })
    }

    return {
      attr,
      dashify
    }
  }
})
